import { PropsWithChildren } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import tw from 'twin.macro';

interface Props {
  seanceId: string;
  isDragDisabled: boolean;
  isFullHeight?: boolean;
}

export function DraggableAndDroppable({
  children,
  seanceId,
  isDragDisabled,
  isFullHeight,
}: PropsWithChildren<Props>) {
  return (
    <Droppable droppableId={seanceId} key={seanceId} isCombineEnabled={true}>
      {(providedDropp, snapshotDropp) => (
        <div
          tw="w-full flex flex-col rounded-lg"
          css={[
            snapshotDropp.isDraggingOver && tw`bg-brand-moderate`,
            isFullHeight && tw`flex-grow`,
          ]}
          ref={providedDropp.innerRef}
          {...providedDropp.droppableProps}
        >
          <Draggable
            draggableId={seanceId}
            index={0} // there is only one item per droppable zone so index is always 0
            isDragDisabled={isDragDisabled}
          >
            {providedDragg => (
              <div
                ref={providedDragg.innerRef}
                {...providedDragg.draggableProps}
                {...providedDragg.dragHandleProps}
                tw="select-none flex"
                css={[isFullHeight && tw`flex-grow`]}
              >
                {children}
              </div>
            )}
          </Draggable>
          <div tw="max-w-1">
            {/* important : keep the placeholder width small to avoid breaking the layout when we drag a larger item over a smaller droppable zone */}
            {providedDropp.placeholder}
          </div>
        </div>
      )}
    </Droppable>
  );
}
